var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextMoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    transform: "rotate(-180 42 42)",
    fill: "#B6C5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9965 18.6289C35.3774 18.0785 34.4293 18.1343 33.8789 18.7535C33.3285 19.3726 33.3843 20.3207 34.0035 20.8711L35.9965 18.6289ZM59.75 41.75L60.7799 42.8405C61.0857 42.5518 61.2562 42.1479 61.2498 41.7274C61.2435 41.3068 61.0609 40.9083 60.7465 40.6289L59.75 41.75ZM33.9701 64.0345C33.3678 64.6033 33.3407 65.5527 33.9095 66.1549C34.4783 66.7572 35.4277 66.7843 36.0299 66.2155L33.9701 64.0345ZM34.0035 20.8711L58.7535 42.8711L60.7465 40.6289L35.9965 18.6289L34.0035 20.8711ZM58.7201 40.6595L33.9701 64.0345L36.0299 66.2155L60.7799 42.8405L58.7201 40.6595Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextMoveIcon);
export default __webpack_public_path__ + "static/media/NextMoveIcon.9511b589533de4c24274c1d7ca332471.svg";
export { ForwardRef as ReactComponent };